import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './SistemaToast.css';

function BotonCerrar({ closeToast }) {
  return (
    <button type="button" className="st-cerrar" onClick={closeToast} aria-label="Cerrar notificación">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        <path d="M6 6l12 12M18 6 6 18" />
      </svg>
    </button>
  );
}

/**
 * Contenedor único de toasts del ERP: se monta una sola vez en App.js, arriba al centro.
 * Para mostrar mensajes usar `notificar` (./notificar), nunca react-toastify ni react-bootstrap directamente.
 */
export default function SistemaToast() {
  return (
    <ToastContainer
      className="st-contenedor"
      style={{ zIndex: 100000 }}
      position="top-center"
      autoClose={4000}
      limit={4}
      newestOnTop
      hideProgressBar
      pauseOnFocusLoss={false}
      closeOnClick={false}
      icon={false}
      closeButton={BotonCerrar}
      toastClassName="st-toast"
      bodyClassName="st-cuerpo"
    />
  );
}
